module.exports = __webpack_public_path__ + "static/media/StartMed.83932e4c.png";